import Api from "./Api.js";

const baseUri = "/reports";

export default {
  getSalesByRepresentative(params) {
    return Api.get(`${baseUri}/sales/by-representative`, {
      params: params,
    });
  },
  getOrdersByRepresentative(params) {
    return Api.get(`${baseUri}/sales/orders-by-representative`, {
      params: params,
    });
  },
  getSalesByChannel(params) {
    return Api.get(`${baseUri}/sales/by-channel`, {
      params: params,
    });
  },
  getSalesPrints(params) {
    return Api.get(`${baseUri}/sales/prints`, {
      params: params,
    });
  },
  getFraudOrders(params) {
    return Api.get(`${baseUri}/fraud-orders`, { params });
  },
  getFreightReport(params) {
    return Api.get(`${baseUri}/freight-orders`, { params });
  },
  getDuplicateOrders(params) {
    return Api.get(`${baseUri}/duplicate-orders`, { params });
  },
  getNewStateRestrictions(params) {
    return Api.get(`${baseUri}/new-state-restrictions`, { params });
  },
  getPartialBackorders(params) {
    return Api.get(`${baseUri}/partial-backorders`, { params });
  },
  getOnHoldSummary() {
    return Api.get(`${baseUri}/on-hold-summary`);
  },
  getBadAddresses() {
    return Api.get(`${baseUri}/bad-addresses`);
  },
  updateBadAddresses(data) {
    return Api.patch(`${baseUri}/bad-addresses`, data);
  },
  getUnprocessedOrders(params) {
    return Api.get(`${baseUri}/unprocessed-orders`, { params });
  },
  updateUnprocessedOrders(data) {
    return Api.patch(`${baseUri}/unprocessed-orders`, data);
  },
  getCreditBalanceDue(params) {
    return Api.get(`${baseUri}/credit-balance-due`, { params });
  },
};
